<div class="dashboard-estudio-container">

	<div class="filters-bar">
		<div class="filters-title">
			<nb-icon icon="calendar-outline"></nb-icon>
			<span>Periodo:</span>
		</div>
		<div class="period-buttons">
			<button *ngFor="let p of periods"
					class="period-btn"
					[class.active]="period === p.key"
					(click)="setPeriod(p.key)">
				{{ p.label }}
			</button>
		</div>
	</div>

	<div class="loading-overlay" *ngIf="loading">
		<div class="loading-card">
			<div class="css-spinner"></div>
			<span class="loading-text">Cargando datos...</span>
		</div>
	</div>

	<div *ngIf="!loading && !dashboardData" class="empty-state">
		<nb-icon icon="alert-circle-outline"></nb-icon>
		<span>No hay datos disponibles</span>
	</div>

	<div *ngIf="dashboardData" class="dashboard-content">

		<div class="kpi-grid">
			<div class="kpi-card kpi-info" *ngIf="level === 'global'">
				<div class="kpi-icon"><nb-icon icon="home-outline"></nb-icon></div>
				<div class="kpi-content">
					<div class="kpi-value">{{ dashboardData.totalCentros || 0 }}</div>
					<div class="kpi-label">Centros totales</div>
				</div>
			</div>

			<div class="kpi-card kpi-primary">
				<div class="kpi-icon"><nb-icon icon="clock-outline"></nb-icon></div>
				<div class="kpi-content">
					<div class="kpi-value">{{ formatTime(dashboardData.tiempoTotalMs) }}</div>
					<div class="kpi-label">Tiempo total</div>
				</div>
			</div>

			<div class="kpi-card kpi-info">
				<div class="kpi-icon"><nb-icon icon="activity-outline"></nb-icon></div>
				<div class="kpi-content">
					<div class="kpi-value">{{ dashboardData.totalSesiones || 0 }}</div>
					<div class="kpi-label">Sesiones totales</div>
				</div>
			</div>

			<div class="kpi-card kpi-success">
				<div class="kpi-icon"><nb-icon icon="people-outline"></nb-icon></div>
				<div class="kpi-content">
					<div class="kpi-value">{{ dashboardData.sesionesProfesor || 0 }}</div>
					<div class="kpi-label">Sesiones como profesor</div>
				</div>
			</div>

			<div class="kpi-card kpi-warning">
				<div class="kpi-icon"><nb-icon icon="edit-outline"></nb-icon></div>
				<div class="kpi-content">
					<div class="kpi-value">{{ dashboardData.sesionesEditor || 0 }}</div>
					<div class="kpi-label">Sesiones como editor</div>
				</div>
			</div>

			<div class="kpi-card kpi-secondary">
				<div class="kpi-icon"><nb-icon icon="question-mark-circle-outline"></nb-icon></div>
				<div class="kpi-content">
					<div class="kpi-value">{{ dashboardData.preguntasCreadas || 0 }}</div>
					<div class="kpi-label">Preguntas creadas</div>
				</div>
			</div>

			<div class="kpi-card kpi-danger">
				<div class="kpi-icon"><nb-icon icon="award-outline"></nb-icon></div>
				<div class="kpi-content">
					<div class="kpi-value">{{ dashboardData.totalDesafios || 0 }}</div>
					<div class="kpi-label">Desafíos</div>
				</div>
			</div>

			<ng-container *ngIf="level === 'global'">
				<div class="kpi-card kpi-info">
					<div class="kpi-icon"><nb-icon icon="message-square-outline"></nb-icon></div>
					<div class="kpi-content">
						<div class="kpi-value">{{ dashboardData.totalRespuestas || 0 }}</div>
						<div class="kpi-label">Respuestas totales</div>
					</div>
				</div>

				<div class="kpi-card kpi-success">
					<div class="kpi-icon"><nb-icon icon="checkmark-circle-2-outline"></nb-icon></div>
					<div class="kpi-content">
						<div class="kpi-value">{{ dashboardData.totalAciertos || 0 }}</div>
						<div class="kpi-label">Respuestas correctas ({{ getGlobalSuccessRate() }}%)</div>
					</div>
				</div>

				<div class="kpi-card kpi-danger">
					<div class="kpi-icon"><nb-icon icon="close-circle-outline"></nb-icon></div>
					<div class="kpi-content">
						<div class="kpi-value">{{ dashboardData.totalFallos || 0 }}</div>
						<div class="kpi-label">Respuestas incorrectas</div>
					</div>
				</div>
			</ng-container>
		</div>

		<div class="charts-row">
			<div class="chart-card chart-large">
				<div class="chart-header">
					<nb-icon icon="bar-chart-outline"></nb-icon>
					<span>Actividad diaria</span>
				</div>
				<div class="chart-body">
					<canvas #activityChart></canvas>
				</div>
			</div>

			<div class="chart-card chart-small">
				<div class="chart-header">
					<nb-icon icon="pie-chart-outline"></nb-icon>
					<span>Distribución por rol</span>
				</div>
				<div class="chart-body">
					<canvas #rolePieChart></canvas>
				</div>
			</div>
		</div>

		<div class="chart-card chart-full" *ngIf="level === 'global'">
			<div class="chart-header chart-header-with-tabs">
				<div class="chart-title">
					<nb-icon icon="trending-up-outline"></nb-icon>
					<span>Acciones de profesores</span>
				</div>
				<div class="actions-tabs">
					<button class="actions-tab" [class.active]="activeActionsTab === 'porTipo'" (click)="setActionsTab('porTipo')">Por tipo</button>
					<button class="actions-tab" [class.active]="activeActionsTab === 'topProfes'" (click)="setActionsTab('topProfes')">Top profesores</button>
					<button class="actions-tab" [class.active]="activeActionsTab === 'timeline'" (click)="setActionsTab('timeline')">Línea temporal</button>
				</div>
			</div>
			<div class="chart-body chart-body-tall">
				<canvas #actionsByTypeChart *ngIf="activeActionsTab === 'porTipo'"></canvas>
				<canvas #topTeachersChart *ngIf="activeActionsTab === 'topProfes'"></canvas>
				<canvas #actionsTimelineChart *ngIf="activeActionsTab === 'timeline'"></canvas>
			</div>
		</div>

		<div class="table-card" *ngIf="level === 'global'">
			<div class="table-header">
				<nb-icon icon="people-outline"></nb-icon>
				<span>Profesores</span>
				<span class="badge">{{ dashboardData.topProfesores?.length || 0 }}</span>
			</div>
			<div class="table-body">
				<table class="data-table" *ngIf="dashboardData.topProfesores?.length > 0; else noTeachers">
					<thead>
						<tr>
							<th class="sortable" (click)="sortTeachers('teacherName')">
								Profesor <span class="sort-icon">{{ getTeachersSortIcon('teacherName') }}</span>
							</th>
							<th class="sortable" (click)="sortTeachers('centerName')">
								Centro <span class="sort-icon">{{ getTeachersSortIcon('centerName') }}</span>
							</th>
							<th class="text-center sortable" (click)="sortTeachers('numDesafios')">
								Desafíos <span class="sort-icon">{{ getTeachersSortIcon('numDesafios') }}</span>
							</th>
							<th class="text-center sortable" (click)="sortTeachers('sesionesEditor')">
								Sesiones editor <span class="sort-icon">{{ getTeachersSortIcon('sesionesEditor') }}</span>
							</th>
							<th class="text-center sortable" (click)="sortTeachers('sesionesProfesor')">
								Sesiones profesor <span class="sort-icon">{{ getTeachersSortIcon('sesionesProfesor') }}</span>
							</th>
							<th class="text-center sortable" (click)="sortTeachers('tiempoTotalMs')">
								Tiempo total <span class="sort-icon">{{ getTeachersSortIcon('tiempoTotalMs') }}</span>
							</th>
							<th class="text-center sortable" (click)="sortTeachers('totalAcciones')">
								Acciones <span class="sort-icon">{{ getTeachersSortIcon('totalAcciones') }}</span>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let p of sortedTeachers">
							<td>
								<a class="teacher-link" *ngIf="p.idCenter; else teacherPlain" (click)="verDashboardProfesorEnCentro(p)">
									{{ p.teacherName || ('Usuario ' + p.idUser) }}
								</a>
								<ng-template #teacherPlain>{{ p.teacherName || ('Usuario ' + p.idUser) }}</ng-template>
							</td>
							<td>{{ p.centerName || '—' }}</td>
							<td class="text-center">{{ p.numDesafios || 0 }}</td>
							<td class="text-center">{{ p.sesionesEditor || 0 }}</td>
							<td class="text-center">{{ p.sesionesProfesor || 0 }}</td>
							<td class="text-center">{{ formatTime(p.tiempoTotalMs) }}</td>
							<td class="text-center">{{ p.totalAcciones || 0 }}</td>
						</tr>
					</tbody>
				</table>
				<ng-template #noTeachers>
					<div class="empty-table">No hay datos de profesores</div>
				</ng-template>
			</div>
		</div>

		<div class="table-card">
			<div class="table-header">
				<nb-icon icon="list-outline"></nb-icon>
				<span>Sesiones recientes</span>
				<span class="badge">{{ dashboardData.sesionesRecientes?.length || 0 }}</span>
			</div>
			<div class="table-body">
				<nb-form-field class="table-search-field" *ngIf="dashboardData.sesionesRecientes?.length > 0">
					<nb-icon nbPrefix icon="search-outline"></nb-icon>
					<input nbInput type="text" placeholder="Buscar..." [(ngModel)]="searchSesiones">
				</nb-form-field>
				<table class="data-table" *ngIf="dashboardData.sesionesRecientes?.length > 0; else noSessions">
					<thead>
						<tr>
							<th class="sortable" *ngIf="level !== 'teacher' && level !== 'teacherCenter'" (click)="sortSesiones('teacherName')">Profesor <span class="sort-icon">{{ getSesionesSortIcon('teacherName') }}</span></th>
							<th class="sortable" (click)="sortSesiones('fecha')">Fecha <span class="sort-icon">{{ getSesionesSortIcon('fecha') }}</span></th>
							<th class="sortable" (click)="sortSesiones('horaInicio')">Inicio <span class="sort-icon">{{ getSesionesSortIcon('horaInicio') }}</span></th>
							<th class="sortable" (click)="sortSesiones('horaFin')">Fin <span class="sort-icon">{{ getSesionesSortIcon('horaFin') }}</span></th>
							<th class="sortable" (click)="sortSesiones('duracionMs')">Duración <span class="sort-icon">{{ getSesionesSortIcon('duracionMs') }}</span></th>
							<th class="sortable" (click)="sortSesiones('role')">Rol <span class="sort-icon">{{ getSesionesSortIcon('role') }}</span></th>
							<th class="sortable" (click)="sortSesiones('accion')">Acción <span class="sort-icon">{{ getSesionesSortIcon('accion') }}</span></th>
							<th class="sortable" *ngIf="level === 'center' || level === 'teacherCenter'" (click)="sortSesiones('groupTitle')">Grupo <span class="sort-icon">{{ getSesionesSortIcon('groupTitle') }}</span></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let s of sesionesRecientesFiltradas">
							<td *ngIf="level !== 'teacher' && level !== 'teacherCenter'">{{ s.teacherName || '—' }}</td>
							<td>{{ s.fecha | date:'dd/MM/yyyy' }}</td>
							<td>{{ s.horaInicio | date:'HH:mm:ss' }}</td>
							<td>{{ s.horaFin | date:'HH:mm:ss' }}</td>
							<td>{{ formatTime(s.duracionMs) }}</td>
							<td><span class="role-badge" [ngClass]="getRolBadgeClass(s.role)">{{ s.role || '—' }}</span></td>
							<td class="ellipsis" [title]="s.accion">{{ s.accion || '—' }}</td>
							<td *ngIf="level === 'center' || level === 'teacherCenter'">{{ s.groupTitle || '—' }}</td>
						</tr>
					</tbody>
				</table>
				<ng-template #noSessions>
					<div class="empty-table">No hay sesiones registradas</div>
				</ng-template>
			</div>
		</div>

		<div class="table-card">
			<div class="table-header">
				<nb-icon icon="trophy-outline"></nb-icon>
				<span>Desafíos lanzados</span>
				<span class="badge">{{ dashboardData.desafios?.length || 0 }}</span>
			</div>
			<div class="table-body">
				<nb-form-field class="table-search-field" *ngIf="dashboardData.desafios?.length > 0">
					<nb-icon nbPrefix icon="search-outline"></nb-icon>
					<input nbInput type="text" placeholder="Buscar..." [(ngModel)]="searchDesafios">
				</nb-form-field>
				<table class="data-table" *ngIf="dashboardData.desafios?.length > 0; else noChallenges">
					<thead>
						<tr>
							<th class="sortable" *ngIf="level !== 'teacher' && level !== 'teacherCenter'" (click)="sortDesafios('teacherName')">Profesor <span class="sort-icon">{{ getDesafiosSortIcon('teacherName') }}</span></th>
							<th class="sortable" *ngIf="level === 'center' || level === 'teacherCenter'" (click)="sortDesafios('groupTitle')">Grupo <span class="sort-icon">{{ getDesafiosSortIcon('groupTitle') }}</span></th>
							<th class="sortable" (click)="sortDesafios('nombreSesion')">Sesión <span class="sort-icon">{{ getDesafiosSortIcon('nombreSesion') }}</span></th>
							<th class="sortable" (click)="sortDesafios('ideografoNombre')">Ideógrafo <span class="sort-icon">{{ getDesafiosSortIcon('ideografoNombre') }}</span></th>
							<th class="sortable" (click)="sortDesafios('courseTitle')">Curso <span class="sort-icon">{{ getDesafiosSortIcon('courseTitle') }}</span></th>
							<th class="text-center sortable" (click)="sortDesafios('totalPreguntas')">Preguntas <span class="sort-icon">{{ getDesafiosSortIcon('totalPreguntas') }}</span></th>
							<th class="text-center sortable" (click)="sortDesafios('aciertos')">Aciertos <span class="sort-icon">{{ getDesafiosSortIcon('aciertos') }}</span></th>
							<th class="text-center sortable" (click)="sortDesafios('fallos')">Fallos <span class="sort-icon">{{ getDesafiosSortIcon('fallos') }}</span></th>
							<th class="text-center sortable" (click)="sortDesafios('successRate')">% Acierto <span class="sort-icon">{{ getDesafiosSortIcon('successRate') }}</span></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let d of desafiosFiltrados">
							<td *ngIf="level !== 'teacher' && level !== 'teacherCenter'">{{ d.teacherName || '—' }}</td>
							<td *ngIf="level === 'center' || level === 'teacherCenter'">{{ d.groupTitle || '—' }}</td>
							<td>{{ d.nombreSesion || ('Sesión ' + d.idSession) }}</td>
							<td>{{ d.ideografoNombre || '—' }}</td>
							<td>{{ d.courseTitle || '—' }}</td>
							<td class="text-center">{{ d.totalPreguntas || 0 }}</td>
							<td class="text-center text-success">{{ d.aciertos || 0 }}</td>
							<td class="text-center text-danger">{{ d.fallos || 0 }}</td>
							<td class="text-center">
								<div class="success-bar">
									<div class="success-bar-fill" [style.width.%]="getSuccessRate(d)"></div>
									<span class="success-bar-text">{{ getSuccessRate(d) }}%</span>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<ng-template #noChallenges>
					<div class="empty-table">No hay desafíos registrados</div>
				</ng-template>
			</div>
		</div>

	</div>
</div>
